import { TooltipOptionOutput } from './tooltip-option-output.model';


export class CustomizeToolTipOutput implements ICustomizeToolTipOutput {
    /** The auto-generated id of the customize tool tip master */
    customize_tooltip_id!: number;
    /** The user group name with 255 character limit */
    customize_tooltip_name!: string;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    tooltip_option!: TooltipOptionOutput[];
    status!: number;

    constructor(data?: ICustomizeToolTipOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customize_tooltip_id = _data["customize_tooltip_id"];
            this.customize_tooltip_name = _data["customize_tooltip_name"];
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            if (Array.isArray(_data["tooltip_option"])) {
                this.tooltip_option = [] as any;
                for (let item of _data["tooltip_option"])
                    this.tooltip_option!.push(TooltipOptionOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CustomizeToolTipOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomizeToolTipOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customize_tooltip_id"] = this.customize_tooltip_id;
        data["customize_tooltip_name"] = this.customize_tooltip_name;
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        if (Array.isArray(this.tooltip_option)) {
            data["tooltip_option"] = [];
            for (let item of this.tooltip_option)
                data["tooltip_option"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface ICustomizeToolTipOutput {
    /** The auto-generated id of the customize tool tip master */
    customize_tooltip_id: number;
    /** The user group name with 255 character limit */
    customize_tooltip_name: string;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    tooltip_option: TooltipOptionOutput[];
    status: number;
}

